import React, { useEffect, useState } from 'react';
import CartIcon from '../../icons/cart';
import { useRecoilState } from 'recoil';
import { Link } from 'react-router-dom';
import { cartState } from '../../atoms';
import { updateCartState } from '../../utils';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {
  const [cart, setCart] = useRecoilState(cartState);

  document.title = `Grocery List by Bora Chung, translated by Anton Hur | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `In <em>Grocery List</em>, the Korean writer Bora Chung reimagines the ghost story as a chilling tale of intimacy with appetite.`);

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Two/BoraChung_02_Mockup1.webp', '../../Series-Two/BoraChung_02_Mockup2.webp']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Grocery List</h1>
            <div className='productAuthor'>Bora Chung</div>
            <div className='productTranslator'>Translated by Anton Hur</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798990416529'} />
            <div className='productPrice'>$14.99 USD</div>
          </div>
          <div className='productExcerpt'>
            ‘Do you know what an ah-gwi is?’ ‘A ghost of someone who starved to death.’ Ghost stories, urban legends, weird tales floating around the Internet, I was into all of that. Sometimes, I would tell her some of them between puffs as we stood there staring at the dumpsters. But this was the first time she had mentioned that stuff on her own.

          </div>

          <div className='productDescription'>In <em>Grocery List</em>, the Korean writer Bora Chung reimagines the ghost story as a chilling tale of intimacy with appetite. The dividing lines of reality and thoughtforms blur as Chung takes on the ever-timely subject of food consciousness. Cutting and evocative, <em>Grocery List</em> is a feast for eaters of all kinds.
          </div>
          <div className='productDescription'>
            <p>Born in Seoul, <strong>Bora Chung</strong> is a distinct new voice in global literature. The author of three novels and three collections of short stories, Chung was shortlisted for the International Booker Prize in 2022. Chung holds an MA in Russian and East European area studies from Yale University and a PhD in Slavic literature from Indiana University. She teaches Russian language and literature and science fiction studies at Yonsei University, and translates modern literary works from Russian and Polish into Korean.</p>
            <p><strong>Anton Hur</strong> was born in Stockholm and currently resides in Seoul. He won a PEN Translates grant for his translation of <em>The Underground Village</em> by Kang Kyeong-ae and a PEN/Heim grant for Bora Chung’s <em>Cursed Bunny</em>, the latter of which was shortlisted for the 2022 International Booker Prize; his translation of Sang Young Park’s <em>Love in the Big City</em> was longlisted for the same prize that year. Other internationally recognized translations include Kyung-Sook <em>Shin’s Violets</em> (2022) and Baek Sehee’s <em>I Want to Die but I Want to Eat Tteokbokki</em> (2018). Also a writer, Hur’s novel, <em>Toward Eternity</em>, a speculative treatment of a transhumanist future, will debut with HarperVia in summer 2024.</p>
          </div>
          <div className='productMetadata'>
            <div>Series II, No. 2</div>
            <div>Summer 2024</div>
            <div>ISBN 9798990416529</div>
            <div>4.125 x 2.75 x 0.54 inches</div>
            <div>80 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)

}